// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"ff45df6d","618":"1a16a1d7"}[chunkId] + ".chunk.css";
};